import "@/App.css";
import { lazy, Suspense } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { LazyMotion, domAnimation } from "framer-motion";
import { ContentProvider } from "@/context/ContentContext";
import Landing from "@/pages/Landing";

// Split off routes most visitors never see — keeps the landing bundle small.
const AdminLogin = lazy(() => import("@/pages/AdminLogin"));
const AdminDashboard = lazy(() => import("@/pages/AdminDashboard"));
const PrivacyPolicy = lazy(() => import("@/pages/PrivacyPolicy"));

function App() {
  return (
    <div className="App">
      <LazyMotion features={domAnimation} strict>
        <ContentProvider>
          <BrowserRouter>
            <Suspense fallback={null}>
              <Routes>
                <Route path="/" element={<Landing />} />
                <Route path="/admin/login" element={<AdminLogin />} />
                <Route path="/admin" element={<AdminDashboard />} />
                <Route path="/privacy-policy" element={<PrivacyPolicy />} />
              </Routes>
            </Suspense>
          </BrowserRouter>
        </ContentProvider>
      </LazyMotion>
    </div>
  );
}

export default App;
